// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const GroupCalendarEditReminders = props => (
    <CalendarEdit {...props} calendarType="reminders" />
);
export default GroupCalendarEditReminders;